import globalHelper from "@/helper";

export const SUBMISSION_STATUS = {
    WAITLISTED: 0,
    REGISTERED: 1,
    EXPIRED: 2,
    CANCELED: 3,
    FULL: 4
};

export const PAYMENT_STATUS = {
    PENDING: 0,
    PAID: 10,
    EXPIRED: 20,
    NOT_STARTED: null
};

export const ATTENDANCE_STATUS = {
    PRESENT: 1,
    ABSENT: 2,
    NOT_MARKED: null
};

export const DEPOSIT_DESTINATION = {
    AWAITING: 0,
    SETTLED: 1,
    DONATED: 2,
    REFUNDED: 3
};

export const REFUND_STATUS = {
    PENDING: 0,
    CONFIRMED: 1
};

export const REFUND_SOURCE = {
    MANUAL_CANCEL: "manual_cancel",
    BLACKLIST: "blacklist"
};

export const ACHIEVEMENT_STATUS = {
    ACHIEVED: 1,
    NOT_ACHIEVED: 2,
    NOT_MARKED: null
};

export const TXN_STATUS = {
    WAITING: 0,
    PENDING: 1,
    PAID: 10,
    PAID_LATE: 11,
    PAID_AFTER_CANCEL: 12,
    CANCEL: 20,
    FAILED: 21,
    EXPIRED: 22,
    CREATION_FAILED: 23
};

export function formatDateWithMs(dateString) {
    if (!dateString || dateString === "null") return "-";

    let parts = dateString.split(" ");
    if (parts.length < 2) {
        parts = dateString.split("T");
    }

    if (parts.length < 2) return globalHelper.parseDate(dateString);

    let datePart = parts[0];
    let timePart = parts[1];

    if (timePart.endsWith("Z")) {
        timePart = timePart.slice(0, -1);
    }

    let parsedDate = globalHelper.parseDate(datePart);
    return `${parsedDate}, ${timePart}`;
}

export function getSubmissionStatusBadge(status) {
    switch (status) {
        case SUBMISSION_STATUS.WAITLISTED:
            return ["warning", "WAITING LIST"];
        case SUBMISSION_STATUS.REGISTERED:
            return ["success", "TERDAFTAR"];
        case SUBMISSION_STATUS.EXPIRED:
            return ["danger", "KEDALUWARSA"];
        case SUBMISSION_STATUS.FULL:
            return ["danger", "KUOTA PENUH"];
        case SUBMISSION_STATUS.CANCELED:
            return ["danger", "DIBATALKAN"];
        default:
            return ["light", "-"];
    }
}

export function getPaymentStatusBadge(status) {
    switch (status) {
        case PAYMENT_STATUS.PENDING:
            return ["warning", "MENUNGGU PEMBAYARAN"];
        case PAYMENT_STATUS.PAID:
            return ["success", "DIBAYAR"];
        case PAYMENT_STATUS.EXPIRED:
            return ["danger", "KEDALUWARSA"];
        case PAYMENT_STATUS.NOT_STARTED:
        default:
            return ["secondary", "BELUM DIBAYAR"];
    }
}

export function getAttendanceStatusBadge(status) {
    switch (status) {
        case ATTENDANCE_STATUS.PRESENT:
            return ["success", "HADIR"];
        case ATTENDANCE_STATUS.ABSENT:
            return ["danger", "ABSEN"];
        case ATTENDANCE_STATUS.NOT_MARKED:
        default:
            return ["secondary", "BELUM DITANDAI"];
    }
}

export function getAchievementStatusBadge(status) {
    switch (status) {
        case ACHIEVEMENT_STATUS.ACHIEVED:
            return ["success", "TERCAPAI"];
        case ACHIEVEMENT_STATUS.NOT_ACHIEVED:
            return ["danger", "TIDAK TERCAPAI"];
        case ACHIEVEMENT_STATUS.NOT_MARKED:
        default:
            return ["secondary", "BELUM DITANDAI"];
    }
}

export function getTxnStatusBadge(status) {
    switch (status) {
        case TXN_STATUS.WAITING:
            return ["warning", "MENUNGGU DOKU"];
        case TXN_STATUS.PENDING:
            return ["warning", "MENUNGGU BAYAR"];
        case TXN_STATUS.PAID:
            return ["success", "DIBAYAR"];
        case TXN_STATUS.PAID_LATE:
            return ["success", "DIBAYAR TERLAMBAT/GAGAL"];
        case TXN_STATUS.PAID_AFTER_CANCEL:
            return ["success", "DIBAYAR SETELAH DIBATALKAN"];
        case TXN_STATUS.CANCEL:
            return ["secondary", "DIBATALKAN"];
        case TXN_STATUS.FAILED:
            return ["danger", "GAGAL"];
        case TXN_STATUS.EXPIRED:
            return ["danger", "KEDALUWARSA"];
        case TXN_STATUS.CREATION_FAILED:
            return ["danger", "GAGAL BAYAR"];
        default:
            return ["light", "-"];
    }
}

export function getPaymentStatusBadgeForConcert(status, requireDP) {
    if (requireDP === false && status === PAYMENT_STATUS.NOT_STARTED) {
        return ["secondary", "TIDAK DIPERLUKAN"];
    }
    return getPaymentStatusBadge(status);
}

export function getRefundStatusBadge(status) {
    switch (status) {
        case REFUND_STATUS.PENDING:
            return ["warning", "MENUNGGU REFUND"];
        case REFUND_STATUS.CONFIRMED:
            return ["success", "REFUND SELESAI"];
        default:
            return ["light", "-"];
    }
}
